import { Header } from "../../components/Header";
import ArrowDoubleSide from "../../components/icons/ArrowDoubleSide";
import Logo from "../../components/icons/Logo";
import "./index.scss";
const AboutUs = () => {
    return (
      <div className="page splash aboutUsPage">
        <div className="background" />
        <Header />
        <div className="logo">
            <Logo />
        </div>
        <div className="triple-text">
            <span>Food Service{'\n'}</span>
            <span>Software Technology{'\n'}</span>
            <span>for Higher Education</span>
        </div>
        <div className="bottom-bar">
          <span>
            Agilysys offers the broadest portfolio of Higher Education{'\n'}
            solutions with the deepest functionality in the market,{'\n'}
            delighting students and faculty and empowering staff to{'\n'}
            provide exceptional service at every touchpoint.
          </span>
        </div>
        <img className="bubbles" src="https://storage.googleapis.com/popshap-kiosks-dev.appspot.com/agilysys/aboutAgilysysHigherEdBubbles.png"/>
      </div>
    );
}
export default AboutUs;